import { render, staticRenderFns } from "./GiftFilters.vue?vue&type=template&id=ee5381a8&"
import script from "./GiftFilters.vue?vue&type=script&lang=js&"
export * from "./GiftFilters.vue?vue&type=script&lang=js&"
import style0 from "./GiftFilters.vue?vue&type=style&index=0&id=ee5381a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
